import React from 'react';
import { TutorialsPageData as pageData } from '../../utils/pageContent';

const InputWithLabel = ({
  id,
  label,
  containerClassName,
  labelClassName,
  error,
  labelMargin,
  errorMargin,
  errorSize,
  className,
  disabled,
  value,
  isRequired,
  limit,
  type = 'text',
  isLengthValidate,
  min,
  max,
  ...props
}) => {
  const sectionData = pageData.editTutorialPageData.tutorialInfoSection.faqFormSection;
  return (
    <div className={containerClassName}>
      {label && (
        <div className="flex items-center justify-between">
          <label
            htmlFor={id}
            className={`font-medium text-shoorah-lightBlack dark:text-white ${labelMargin ? labelMargin : 'mb-2'
              } block ${labelClassName ? labelClassName : ''}`}
          >
            {label}
            {isRequired && !disabled && <span className="text-red-500"> &#42;</span>}
          </label>
          {isLengthValidate && !disabled && (
            <span className="mt-1 float-right text-red-500 text-[12px]">
              {value?.length <= limit
                ? limit - value?.length + sectionData.characterLeftText
                : sectionData.outOf100Text}
            </span>
          )}
        </div>
      )}
      <input
        className={`w-full rounded-lg px-4 py-[9px] text-sm text-shoorah-lightBlack 
          dark:border-shoorah-darkBorder dark:text-white bg-shoorah-normanGray dark:bg-shoorah-darkBgColor
           border-[1.5px] border-shoorah-borderGray ${className ? className : ''
          } focus:outline-none`}
        type={type}
        autoComplete="off"
        id={id}
        disabled={disabled}
        value={value}
        // value={typeof value === 'number' ? new Intl.NumberFormat('en-IN').format(value) : value}
        {...(type === 'number' ? { min, max } : {})}
        {...props}
      />
      {error && (
        <p
          className={`text-red-500 ${errorSize ? errorSize : 'text-sm'} ${errorMargin ? errorMargin : 'mt-2'
            }`}
        >
          {error}
        </p>
      )}
    </div>
  );
};

export default InputWithLabel;
